'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RenameWindow = undefined;

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _FavoriteTextCmp = require('./FavoriteTextCmp');

var _FavoriteTextCmp2 = _interopRequireDefault(_FavoriteTextCmp);

var _FavoriteStyle = require('./FavoriteStyle');

var _FavoriteStyle2 = _interopRequireDefault(_FavoriteStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RenameWindow = exports.RenameWindow = undefined;

exports.RenameWindow = RenameWindow = function RenameWindow(refs, layout, fn, listeners) {
    var t = this,
        appManager = refs.appManager,
        uiManager = refs.uiManager,
        instanceManager = refs.instanceManager,
        i18n = refs.i18nManager.get(),
        uiConfig = refs.uiConfig,
        api = refs.api,
        apiPath = appManager.getApiPath(),
        apiEndpoint = instanceManager.apiEndpoint;

    listeners = listeners || {};

    var _getFavoriteTextCmp = (0, _FavoriteTextCmp2.default)({ layout: layout, i18n: i18n }),
        nameTextField = _getFavoriteTextCmp.nameTextField,
        descriptionTextField = _getFavoriteTextCmp.descriptionTextField;

    var renameButton = Ext.create('Ext.button.Button', {
        text: i18n.update,
        handler: function handler() {
            var name = nameTextField.getValue(),
                description = descriptionTextField.getValue(),
                patch = function patch() {
                var properties = {
                    name: name,
                    description: description
                };

                layout.apply(properties);

                layout.patch(properties, function () {
                    if (fn) {
                        fn();
                    }
                    instanceManager.getById(null, function (layout, isFavorite) {
                        instanceManager.getReport(layout, isFavorite, false, false, function () {
                            uiManager.unmask();
                        });
                    });
                    window.destroy();
                }, true, true);
            };

            if (layout.patch) {
                patch();
            } else {
                var fields = appManager.getAnalysisFields(),
                    url = apiPath + '/' + apiEndpoint + '/' + layout.id + '.json?fields=' + fields;

                $.getJSON(encodeURI(url), function (r) {
                    layout = new api.Layout(refs, r).val();
                    patch();
                });
            }
        }
    });

    var cancelButton = Ext.create('Ext.button.Button', {
        text: i18n.cancel,
        handler: function handler() {
            window.destroy();
        }
    });

    var window = Ext.create('Ext.window.Window', {
        title: id ? 'Rename favorite' : 'Create new favorite',
        bodyStyle: 'padding:1px; background:#fff',
        resizable: false,
        modal: true,
        items: [nameTextField, descriptionTextField],
        destroyOnBlur: true,
        bbar: [cancelButton, '->', renameButton],
        listeners: {
            show: function show(w) {
                var favoriteButton = uiManager.get('favoriteButton') || {};

                if (favoriteButton.rendered) {
                    uiManager.setAnchorPosition(w, favoriteButton);

                    if (!w.hasDestroyOnBlurHandler) {
                        uiManager.addDestroyOnBlurHandler(w);
                    }
                }

                nameTextField.focus(false, 500);

                if (listeners.show) {
                    listeners.show();
                }
            },
            destroy: function destroy() {
                if (listeners.destroy) {
                    listeners.destroy();
                }
            }
        }
    });

    return window;
};
//# sourceMappingURL=RenameWindow.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/ui/RenameWindow.js
 ** module id = 45
 ** module chunks = 0 1
 **/